import React from 'react'
import _About from '../Components/About'
import Mission from '../Components/Mission'
import WhyChooseUs from '../Components/WhyChooseUs'
import ContactInfo from '../Components/ContactInfo'

function About () {
  return (
    <>
    <_About/>
    <Mission/>
    <WhyChooseUs/>
    <ContactInfo/>
    </>
  )
}

export default About
